import React, { useState, useRef, useEffect } from "react";
import { Box, Button as ThemeUiButton, Text } from "theme-ui";

import * as styles from "./ImageCarousel.styles";
import { SvgOrImg } from "components";

export default function ImageCarousel({
  images = [],
  productColor,
  textColor,
  cornerTag,
  disableScroll = false,
}) {
  const [activeSlide, setActiveSlide] = useState(0);
  const wrapperRef = useRef(null);

  const handleScroll = () => {
    const { width } = wrapperRef.current.getBoundingClientRect();
    const { scrollLeft } = wrapperRef.current;
    setActiveSlide(Math.round(scrollLeft / width));
  };

  const scrollCarouselOnClick = (index) => {
    const { width } = wrapperRef.current.getBoundingClientRect();
    wrapperRef.current.scrollLeft = width * index;
  };

  useEffect(() => {
    scrollCarouselOnClick(0);
  }, [JSON.stringify(images)]);

  return (
    <Box sx={styles.carouselContainer}>
      <Box
        ref={wrapperRef}
        sx={styles.carouselScrollContainer({ disableScroll })}
        onScroll={handleScroll}
      >
        <Box sx={styles.carouselMedia}>
          {images.map(({ url, alt, cornerText }, index) => {
            return (
              <Box sx={styles.carouselItem} key={index + url}>
                <SvgOrImg src={url} alt={alt || ""} sx={styles.displayImage} />
                {cornerText && (
                  <Text variant="h6" sx={styles.cornerText({ textColor })}>
                    {cornerText}
                  </Text>
                )}
              </Box>
            );
          })}
        </Box>
      </Box>

      {cornerTag && (
        <Box sx={styles.cornerTag}>
          <SvgOrImg
            src={cornerTag.logo.url}
            alt={cornerTag.logo.alt}
            sx={styles.cornerTagImg}
          />
          <Text sx={styles.cornerTagText}>{cornerTag.text}</Text>
        </Box>
      )}

      <Box sx={styles.paginationDots}>
        {images.map(({ url }, index) => {
          return (
            <ThemeUiButton
              variant="unstyled"
              sx={styles.paginationDot({
                isSelected: index === activeSlide,
                textColor,
                dotColor: productColor,
              })}
              onClick={() => scrollCarouselOnClick(index)}
              key={"pagination" + index + url}
            />
          );
        })}
      </Box>
    </Box>
  );
}
